var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "params-form" },
        [
          _c(
            "a-form-model",
            {
              ref: "searchForm",
              attrs: { layout: "inline", model: _vm.formState },
            },
            [
              _c(
                "a-form-model-item",
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.lookIndex },
                    },
                    [_vm._v("返回")]
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "农产品名称", prop: "produceName" } },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.formState.produceName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "produceName", $$v)
                      },
                      expression: "formState.produceName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "污染物名称", prop: "badName" } },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.formState.badName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "badName", $$v)
                      },
                      expression: "formState.badName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "单位", prop: "unit" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block", width: "150px" },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "Unit" },
                        model: {
                          value: _vm.formState.unit,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "unit", $$v)
                          },
                          expression: "formState.unit",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "判定值来源", prop: "valueFrom" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block", width: "150px" },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          model: {
                            value: _vm.formState.valueFrom,
                            callback: function ($$v) {
                              _vm.$set(_vm.formState, "valueFrom", $$v)
                            },
                            expression: "formState.valueFrom",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "参考" } }, [
                            _vm._v("参考"),
                          ]),
                          _c(
                            "a-select-option",
                            { attrs: { value: "自定义" } },
                            [_vm._v("自定义")]
                          ),
                          _c("a-select-option", { attrs: { value: "引用" } }, [
                            _vm._v("引用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "使用规定", prop: "useFor" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block", width: "150px" },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "JudgeUseFor" },
                        model: {
                          value: _vm.formState.useFor,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "useFor", $$v)
                          },
                          expression: "formState.useFor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                [
                  _c(
                    "a-space",
                    [
                      _c("a-button", { on: { click: _vm.onResetSearch } }, [
                        _vm._v("重置"),
                      ]),
                      _c("a-divider", {
                        attrs: { dashed: "true", type: "vertical" },
                      }),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSearchPage },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-content" },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "title",
                staticStyle: { width: "350px", display: "inline-block" },
              },
              [
                _vm._v(" 判定标准版本 "),
                _vm.selectedRowCount
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          width: "150px",
                          display: "inline-block",
                          "line-height": "20px",
                          color: "darkorange",
                        },
                      },
                      [_vm._v("共选择" + _vm._s(_vm.selectedRowCount) + "条")]
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                staticStyle: {
                  width: "calc(100% - 350px)",
                  display: "inline-block",
                  "text-align": "right",
                },
              },
              [
                _c(
                  "a-space",
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onQuickSetClick },
                      },
                      [_vm._v("快速设定")]
                    ),
                    _c("a-divider", {
                      attrs: { dashed: "true", type: "vertical" },
                    }),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.onBatchDelete },
                      },
                      [_vm._v("批量删除")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "a-config-provider",
            { attrs: { locale: _vm.locale } },
            [
              _c("a-table", {
                attrs: {
                  "data-source": _vm.dataSource,
                  columns: _vm.columns,
                  pagination: _vm.pagination,
                  loading: _vm.loading,
                  "row-key": "id",
                  "row-selection": {
                    selectedRowKeys: _vm.selectedRowKeys,
                    onChange: _vm.onSelectChange,
                  },
                  customRow: _vm.customRow,
                  scroll: { y: 500 },
                },
                on: { change: _vm.onPageChange },
                scopedSlots: _vm._u([
                  {
                    key: "judgeValue",
                    fn: function (text, record) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              dblclick: function ($event) {
                                return _vm.handleCellStatusChange(
                                  record,
                                  "judgeValue"
                                )
                              },
                            },
                          },
                          [
                            record.editable.judgeValue
                              ? _c("a-input-number", {
                                  model: {
                                    value: record.judgeValue,
                                    callback: function ($$v) {
                                      _vm.$set(record, "judgeValue", $$v)
                                    },
                                    expression: "record.judgeValue",
                                  },
                                })
                              : [
                                  _vm._v(
                                    " " + _vm._s(record.judgeValue || "-") + " "
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    },
                  },
                  {
                    key: "judgeUnit",
                    fn: function (text, record) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              dblclick: function ($event) {
                                return _vm.handleCellStatusChange(
                                  record,
                                  "judgeUnit"
                                )
                              },
                            },
                          },
                          [
                            record.editable.judgeUnit
                              ? _c(
                                  "a-select",
                                  {
                                    model: {
                                      value: record.judgeUnit,
                                      callback: function ($$v) {
                                        _vm.$set(record, "judgeUnit", $$v)
                                      },
                                      expression: "record.judgeUnit",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "mg/kg" } },
                                      [_vm._v("mg/kg")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "g/kg" } },
                                      [_vm._v("g/kg")]
                                    ),
                                  ],
                                  1
                                )
                              : [
                                  _vm._v(
                                    " " + _vm._s(record.judgeUnit || "-") + " "
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    },
                  },
                  {
                    key: "valueFrom",
                    fn: function (text, record) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              dblclick: function ($event) {
                                return _vm.handleCellStatusChange(
                                  record,
                                  "valueFrom"
                                )
                              },
                            },
                          },
                          [
                            record.editable.valueFrom
                              ? _c(
                                  "a-select",
                                  {
                                    model: {
                                      value: record.valueFrom,
                                      callback: function ($$v) {
                                        _vm.$set(record, "valueFrom", $$v)
                                      },
                                      expression: "record.valueFrom",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "参考" } },
                                      [_vm._v("参考")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "自定义" } },
                                      [_vm._v("自定义")]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "引用" } },
                                      [_vm._v("引用")]
                                    ),
                                  ],
                                  1
                                )
                              : [
                                  _vm._v(
                                    " " + _vm._s(record.valueFrom || "-") + " "
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    },
                  },
                  {
                    key: "useFor",
                    fn: function (text, record) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              dblclick: function ($event) {
                                return _vm.handleCellStatusChange(
                                  record,
                                  "useFor"
                                )
                              },
                            },
                          },
                          [
                            record.editable.useFor
                              ? _c("a-input", {
                                  model: {
                                    value: record.useFor,
                                    callback: function ($$v) {
                                      _vm.$set(record, "useFor", $$v)
                                    },
                                    expression: "record.useFor",
                                  },
                                })
                              : [
                                  _vm._v(
                                    " " + _vm._s(record.useFor || "-") + " "
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    },
                  },
                  {
                    key: "caozuo",
                    fn: function (text, record) {
                      return [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "link" },
                            on: {
                              click: function ($event) {
                                return _vm.onQuickSetClick(record)
                              },
                            },
                          },
                          [_vm._v("设定")]
                        ),
                        _c("a-divider", {
                          attrs: { dashed: "true", type: "vertical" },
                        }),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "link" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(record)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.addQuickSetModalVisable
        ? _c("add-quick-set-modal", {
            attrs: {
              visible: _vm.addQuickSetModalVisable,
              param: _vm.addQuickSetModalParam,
            },
            on: {
              "update:visible": function ($event) {
                _vm.addQuickSetModalVisable = $event
              },
              addModalClose: _vm.onAddQuickSetModalClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }